import CampaignTemplateBudget from "@routes/Keyword/templates/CampaignTemplate/CampaignTemplateBudget";
import TemplateKeywordDefault from "@routes/Keyword/templates/TemplateKeywordDefault/TemplateKeywordDefault";
import { KeywordPageData } from "@routes/Keyword/utils/types";

/** The content of the keyword page. Separated by template. */
const KeywordPageContent = (data: KeywordPageData): React.ReactElement => {
  if (data.template === "campaignTemplate1Budget") {
    return <CampaignTemplateBudget {...data} />;
  }

  return <TemplateKeywordDefault {...data} />;
};

export default KeywordPageContent;
